<template>
	<section class="group">
		<div ref="content" class="groupContent" :style="`max-width: ${maxWidth}px`">
			<Party
				v-for="item in group"
				:key="item.partyId"
				:item="item"
				:size="tokenSize"
				@click.native="onClickParty()"
			/>
		</div>
	</section>
</template>

<script lang="js">
import Party from '@/components/Results/Radar/Party'

export default {
	props: {
		group: Array,
		index: Number,
	},

	components: {
		Party
	},

	computed:{
		tokenSize(){
			if(this.index <= 2){
				return 'large'
			} if(this.index > 2 && this.index <= 5){
				return 'medium'
			}

			return 'small'
		},

		maxWidth(){
			return 105 * Math.min(4, this.group.length)
		},

		height(){
			return this.$el.offsetHeight
		}
	},

	mounted(){
		// emit each height of the circle to an array in the parent
		this.$emit('onSizeUpdate', this.height)
	},

	methods:{

		// emit click event to hide the tooltip in parent
		onClickParty(){
			this.$emit('onClickParty')
		}
	}
}
</script>

<style scoped lang="scss">
.group {
	padding: 30px 0;
}

.groupContent {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	flex-wrap: wrap;
	margin: 0 auto;
}
</style>
